module.exports = __webpack_public_path__ + "img/monoblock.a7cea927.png";